import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mx-auto w-full max-w-[1380px] px-4 py-6 font-inter text-foreground" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "flex flex-wrap items-end justify-between gap-3" }
const _hoisted_4 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_5 = {
  key: 0,
  class: "inline-flex h-fit rounded-full bg-[#f5f5f5] px-3 py-1 text-xs font-semibold text-[#737373]"
}
const _hoisted_6 = { class: "mt-1 max-w-3xl text-sm text-gray-500" }
const _hoisted_7 = { class: "rounded-xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_8 = { class: "grid gap-3 md:grid-cols-[auto,minmax(0,1fr),auto]" }
const _hoisted_9 = { class: "flex items-end" }
const _hoisted_10 = { class: "inline-flex overflow-hidden rounded-2xl border border-slate-300 bg-gradient-to-br from-slate-100 via-white to-slate-50 p-1.5 shadow-sm ring-1 ring-slate-200/70" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "flex items-end gap-2" }
const _hoisted_13 = ["checked"]
const _hoisted_14 = {
  key: 0,
  class: "mt-4 flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-3 text-sm text-muted-foreground"
}
const _hoisted_15 = {
  key: 1,
  class: "mt-6 rounded-xl border border-amber-200 bg-amber-50 p-5 text-amber-900"
}
const _hoisted_16 = {
  key: 2,
  class: "mt-5 grid gap-5 xl:grid-cols-[300px,minmax(0,1fr)]"
}
const _hoisted_17 = { class: "h-fit rounded-2xl border border-slate-200 bg-white shadow-sm xl:sticky xl:top-4" }
const _hoisted_18 = { class: "flex items-center justify-between gap-2 border-b border-slate-200 px-4 py-3" }
const _hoisted_19 = {
  key: 0,
  class: "inline-flex items-center rounded-full bg-[#f5f5f5] px-2.5 py-1 text-[11px] font-semibold text-[#737373]"
}
const _hoisted_20 = { class: "max-h-[calc(100vh-8rem)] space-y-5 overflow-auto px-4 py-4" }
const _hoisted_21 = { class: "space-y-2" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "space-y-2" }
const _hoisted_24 = { class: "space-y-1.5" }
const _hoisted_25 = ["checked", "onChange"]
const _hoisted_26 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_27 = { class: "space-y-1.5" }
const _hoisted_28 = ["checked", "onChange"]
const _hoisted_29 = { class: "space-y-2" }
const _hoisted_30 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 1,
  class: "flex flex-wrap gap-2"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 2,
  class: "text-xs text-slate-500"
}
const _hoisted_35 = { class: "space-y-2" }
const _hoisted_36 = { class: "space-y-1.5" }
const _hoisted_37 = ["checked", "onChange"]
const _hoisted_38 = { class: "space-y-2" }
const _hoisted_39 = { class: "space-y-1.5" }
const _hoisted_40 = ["checked", "onChange"]
const _hoisted_41 = { class: "space-y-2" }
const _hoisted_42 = { class: "space-y-1.5" }
const _hoisted_43 = ["checked", "onChange"]
const _hoisted_44 = { class: "space-y-2" }
const _hoisted_45 = { class: "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm text-slate-700 transition hover:bg-slate-50" }
const _hoisted_46 = { class: "space-y-2" }
const _hoisted_47 = { class: "space-y-1.5" }
const _hoisted_48 = ["checked", "onChange"]
const _hoisted_49 = { class: "space-y-2" }
const _hoisted_50 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 1,
  class: "flex flex-wrap gap-2"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 2,
  class: "text-xs text-slate-500"
}
const _hoisted_55 = { class: "space-y-2" }
const _hoisted_56 = { class: "space-y-1.5" }
const _hoisted_57 = ["checked", "onChange"]
const _hoisted_58 = { class: "grid gap-4 xl:grid-cols-[minmax(0,1fr),440px]" }
const _hoisted_59 = { class: "min-w-0" }
const _hoisted_60 = { class: "mb-3 flex flex-wrap items-center justify-between gap-2" }
const _hoisted_61 = { class: "text-sm font-semibold text-slate-700" }
const _hoisted_62 = { class: "text-xs font-medium text-slate-500" }
const _hoisted_63 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_64 = {
  key: 1,
  class: "rounded-xl border border-slate-200 bg-white p-8 text-center text-slate-500"
}
const _hoisted_65 = {
  key: 2,
  class: "rounded-xl border border-slate-200 bg-white p-8 text-center text-slate-500"
}
const _hoisted_66 = {
  key: 3,
  class: "rounded-xl border border-slate-200 bg-white p-8 text-center text-slate-500"
}
const _hoisted_67 = ["onMouseenter"]
const _hoisted_68 = { class: "flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between" }
const _hoisted_69 = { class: "min-w-0 flex-1" }
const _hoisted_70 = { class: "flex items-start gap-3" }
const _hoisted_71 = {
  key: 0,
  class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white p-2 shadow-sm"
}
const _hoisted_72 = ["src", "alt"]
const _hoisted_73 = { class: "min-w-0 flex-1" }
const _hoisted_74 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_75 = {
  key: 1,
  class: "truncate text-base font-semibold leading-tight text-slate-900"
}
const _hoisted_76 = {
  key: 2,
  class: "inline-flex rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-600"
}
const _hoisted_77 = {
  key: 3,
  class: "inline-flex rounded-full bg-sky-50 px-2 py-0.5 text-[11px] font-semibold text-sky-700 ring-1 ring-sky-100"
}
const _hoisted_78 = ["disabled", "aria-label", "title", "onClick"]
const _hoisted_79 = { class: "mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-500" }
const _hoisted_80 = ["title"]
const _hoisted_81 = ["href"]
const _hoisted_82 = {
  key: 0,
  class: "mt-2 line-clamp-1 text-sm leading-relaxed text-slate-600"
}
const _hoisted_83 = { class: "mt-3 flex flex-wrap items-center gap-2" }
const _hoisted_84 = {
  key: 0,
  class: "rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold text-slate-600"
}
const _hoisted_85 = { class: "grid min-w-0 shrink-0 grid-cols-2 gap-3 xl:w-[220px] xl:grid-cols-1 xl:text-right" }
const _hoisted_86 = {
  key: 0,
  class: "mt-1 text-sm font-semibold text-slate-700"
}
const _hoisted_87 = {
  key: 1,
  class: "mt-1 text-sm font-semibold text-slate-900"
}
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "text-[11px] font-semibold uppercase tracking-wide text-slate-500" }
const _hoisted_90 = { class: "mt-1 text-sm font-semibold text-slate-900" }
const _hoisted_91 = ["onMouseenter"]
const _hoisted_92 = { class: "flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between" }
const _hoisted_93 = { class: "min-w-0 flex-1" }
const _hoisted_94 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_95 = { class: "truncate text-base font-semibold leading-tight text-slate-900" }
const _hoisted_96 = {
  key: 0,
  class: "inline-flex rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-semibold text-amber-700 ring-1 ring-amber-100"
}
const _hoisted_97 = { class: "mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-500" }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = { key: 2 }
const _hoisted_100 = {
  key: 0,
  class: "mt-2 line-clamp-2 text-sm leading-relaxed text-slate-600"
}
const _hoisted_101 = { class: "mt-3 flex flex-wrap items-center gap-2" }
const _hoisted_102 = {
  key: 0,
  class: "rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold text-slate-600"
}
const _hoisted_103 = {
  key: 1,
  class: "mt-3 rounded-lg bg-slate-50 px-3 py-2 text-sm text-slate-600"
}
const _hoisted_104 = { class: "text-[11px] font-semibold uppercase tracking-wide text-slate-500" }
const _hoisted_105 = { key: 0 }
const _hoisted_106 = { class: "mt-1 line-clamp-2" }
const _hoisted_107 = { class: "grid shrink-0 grid-cols-1 gap-3 xl:min-w-[220px] xl:text-right" }
const _hoisted_108 = { class: "mt-1 text-sm font-semibold text-slate-900" }
const _hoisted_109 = {
  key: 6,
  class: "mt-4 flex items-center justify-center gap-2"
}
const _hoisted_110 = ["disabled"]
const _hoisted_111 = { class: "rounded-md bg-slate-900 px-3 py-1.5 text-sm font-semibold text-white" }
const _hoisted_112 = ["disabled"]
const _hoisted_113 = { class: "hidden h-fit xl:block xl:sticky xl:top-4" }

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Bookmark } from 'lucide-vue-next'
import { COMMODITIES, EMPLOYEE_SIZES, PROJECT_STAGES } from '@/constants/lookups'
import { formatMarketCap } from '@/composables/useCompanyMarketData'
import { formatDateAsDayMonthYear } from '@/utils/formatters'
import { getCompanyIndustryOptions } from '@/api/shared/industries'
import type { CompanyIndustryOption, CompanyIndustrySubcategory } from '@/types/company'
import CompanyDirectoryMap from '@/components/marketplace/contractor/CompanyDirectoryMap.vue'
import {
  bookmarkContractorCompany,
  getContractorMiningCompanies,
  removeContractorCompanyBookmark,
} from '@/api/contractor/company'

type SearchMode = 'company' | 'project'

type CompanyListItem = {
  id: number | null
  name: string
  slug: string
  logo: string
  website: string
  office_address: string
  summary: string
  market_cap: number | string | null
  cash_in_bank: number | string | null
  cash_runway: number | string | null
  is_private_company: boolean
  is_bookmarked: boolean
  industry_subcategory: string
  industry_subcategory_id?: number | string | null
  commodities: string[]
  office_location_lat?: number | string | null
  office_location_lng?: number | string | null
}

type ProjectListItem = {
  id: string
  name: string
  stage: string
  description: string
  location_label: string
  location_lat: number | string | null
  location_lng: number | string | null
  commodities: string[]
  activity_feed: Array<{ date: string; text: string }>
  company_id: number | string | null
  company_name: string
  company_slug: string
}

type SortOption = {
  value: string
  label: string
}

type CashBandOption = {
  value: string
  label: string
}

const PER_PAGE = 20

const SHOW_SUBCATEGORY_FILTER = true

export default /*@__PURE__*/_defineComponent({
  __name: 'CompanySearch',
  setup(__props) {

const JOB_STATE_FILTERS = [
  { value: 'NSW', label: 'NSW' },
  { value: 'QLD', label: 'QLD' },
  { value: 'WA', label: 'WA' },
  { value: 'SA', label: 'SA' },
  { value: 'VIC', label: 'VIC' },
  { value: 'TAS', label: 'TAS' },
  { value: 'NT', label: 'NT' },
  { value: 'ACT', label: 'ACT' },
  { value: 'Overseas', label: 'Overseas' },
] as const
const EMPLOYEE_SIZE_FILTERS = EMPLOYEE_SIZES
const COMPANY_SORT_OPTIONS: SortOption[] = [
  { value: 'market_cap_desc', label: 'Market Cap: High to low' },
  { value: 'market_cap_asc', label: 'Market Cap: Low to high' },
  { value: 'cash_in_bank_desc', label: 'Cash in Bank: High to low' },
  { value: 'cash_in_bank_asc', label: 'Cash in Bank: Low to high' },
  { value: 'cash_runway_desc', label: 'Cash Runway: High to low' },
  { value: 'cash_runway_asc', label: 'Cash Runway: Low to high' },
  { value: 'name_asc', label: 'Name (A-Z)' },
  { value: 'name_desc', label: 'Name (Z-A)' },
]
const PROJECT_SORT_OPTIONS: SortOption[] = [
  { value: 'name_asc', label: 'Project Name (A-Z)' },
  { value: 'name_desc', label: 'Project Name (Z-A)' },
  { value: 'company_asc', label: 'Company (A-Z)' },
  { value: 'company_desc', label: 'Company (Z-A)' },
  { value: 'stage_asc', label: 'Stage (A-Z)' },
  { value: 'stage_desc', label: 'Stage (Z-A)' },
]
const CASH_BANDS: CashBandOption[] = [
  { value: '', label: 'All ranges' },
  { value: 'lt_3m', label: '< $3m' },
  { value: '3m_8m', label: '$3m to $8m' },
  { value: '8m_20m', label: '$8m to $20m' },
  { value: 'gte_20m', label: '$20m+' },
]
const INDUSTRY_FILTERS = [
  { value: 'mining', label: 'Mining' },
  { value: 'energy', label: 'Energy' },
]
const route = useRoute()
const router = useRouter()

const isAccessLoading = ref(true)
const isAllowed = ref(false)
const isLoading = ref(false)
const hasBootstrapped = ref(false)
const isSyncingFromRoute = ref(false)
const lastLocallySyncedQuery = ref<string | null>(null)
const selectedResultId = ref<string | number | null>(null)

const activeMode = ref<SearchMode>('company')
const searchQuery = ref('')
const commoditySearchQuery = ref('')
const sort = ref('market_cap_desc')
const selectedIndustries = ref<string[]>([])
// Subcategory filter only exposes these subcategories; set SHOW_SUBCATEGORY_FILTER to false to hide it.
const VISIBLE_SUBCATEGORY_SLUGS = new Set(['explorer', 'producer'])
const selectedIndustrySubcategories = ref<string[]>([])
const selectedStates = ref<string[]>([])
const selectedCommodities = ref<string[]>([])
const selectedCashBands = ref<string[]>([])
const selectedEmployeeSizes = ref<string[]>([])
const hasActiveJobs = ref(false)
const selectedProjectStates = ref<string[]>([])
const selectedProjectStages = ref<string[]>([])
const bookmarkedOnly = ref(false)
const bookmarkSavingIds = ref<Set<number>>(new Set())

const companyDirectoryTotal = ref(0)
const projectDirectoryTotal = ref(0)
const companyResultTotal = ref<number | null>(null)
const projectResultTotal = ref<number | null>(null)
const companyItems = ref<CompanyListItem[]>([])
const projectItems = ref<ProjectListItem[]>([])
const companyIndustryOptions = ref<CompanyIndustryOption[]>([])
const total = ref(0)
const page = ref(1)

const defaultSortForMode = (mode: SearchMode): string => (mode === 'project' ? 'name_asc' : 'market_cap_desc')

const parseMode = (value: unknown): SearchMode => {
  const raw = Array.isArray(value) ? value[0] : value
  return raw === 'project' ? 'project' : 'company'
}

const parseQueryArray = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean)
  }

  if (typeof value === 'string') {
    return value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
  }

  return []
}

const parseQueryString = (value: unknown): string => {
  if (Array.isArray(value)) {
    return typeof value[0] === 'string' ? value[0] : ''
  }

  return typeof value === 'string' ? value : ''
}

const parseQueryPage = (value: unknown): number => {
  const rawValue = Array.isArray(value) ? value[0] : value
  const parsed = Number(rawValue)
  return Number.isInteger(parsed) && parsed > 0 ? parsed : 1
}

const pageTitle = computed(() =>
  bookmarkedOnly.value
    ? 'Bookmarked Companies'
    : (activeMode.value === 'project' ? 'Search Projects' : 'Search Companies')
)
const pageSubtitle = computed(() =>
  bookmarkedOnly.value
    ? 'Review the companies you have bookmarked from the mining directory.'
    : (
  activeMode.value === 'project'
    ? 'Discover mining projects across Australia, then filter by stage, location, and commodities.'
    : 'Explore mining companies, compare market position and head office footprint, and open full profiles with project-level detail.'
    )
)
const searchPlaceholder = computed(() =>
  activeMode.value === 'project'
    ? 'Search projects, companies, commodities...'
    : 'Search companies, summaries, head offices...'
)
const sortOptions = computed(() => (activeMode.value === 'project' ? PROJECT_SORT_OPTIONS : COMPANY_SORT_OPTIONS))
const stateOptions = computed(() => JOB_STATE_FILTERS)
const displayDirectoryTotal = computed(() =>
  activeMode.value === 'project'
    ? (projectResultTotal.value ?? projectDirectoryTotal.value)
    : (companyResultTotal.value ?? companyDirectoryTotal.value)
)
const totalPages = computed(() => Math.max(1, Math.ceil(total.value / PER_PAGE)))
const resultsSummary = computed(() => {
  const singular = activeMode.value === 'project' ? 'project' : 'company'
  const plural = activeMode.value === 'project' ? 'projects' : 'companies'

  if (total.value === 0) {
    return `Showing 0 of 0 ${plural}`
  }

  const start = (page.value - 1) * PER_PAGE + 1
  const end = Math.min(start + (activeMode.value === 'project' ? projectItems.value.length : companyItems.value.length) - 1, total.value)

  return `Showing ${start.toLocaleString()}–${end.toLocaleString()} of ${total.value.toLocaleString()} ${total.value === 1 ? singular : plural}`
})
const activeFilterCount = computed(() => {
  if (bookmarkedOnly.value) {
    return 0
  }

  let count = 0
  if (searchQuery.value.trim()) count += 1
  count += selectedIndustries.value.length
  if (activeMode.value === 'company') {
    count += selectedIndustrySubcategories.value.length
  }
  count += selectedCommodities.value.length

  if (activeMode.value === 'project') {
    count += selectedProjectStages.value.length
    count += selectedProjectStates.value.length
    return count
  }

  count += selectedStates.value.length
  count += selectedCashBands.value.length
  count += selectedEmployeeSizes.value.length
  if (hasActiveJobs.value) count += 1
  return count
})
const mappableCompanies = computed(() =>
  companyItems.value.filter((company) => company.office_address && company.office_address.trim() !== '')
)
const activeCommodityOptions = computed(() => {
  const sourceItems = activeMode.value === 'project' ? projectItems.value : companyItems.value
  const set = new Set<string>(COMMODITIES)

  sourceItems.forEach((item) => {
    const commodities = Array.isArray(item.commodities) ? item.commodities : []
    commodities.forEach((commodity) => {
      const trimmed = String(commodity || '').trim()
      if (trimmed) {
        set.add(trimmed)
      }
    })
  })

  return Array.from(set).sort((a, b) => a.localeCompare(b))
})
const companySubcategoryOptions = computed<CompanyIndustrySubcategory[]>(() => {
  const selectedIndustrySet = new Set(selectedIndustries.value.map((industry) => industry.toLowerCase()))
  const relevantIndustries = selectedIndustrySet.size
    ? companyIndustryOptions.value.filter((industry) => selectedIndustrySet.has(industry.slug.toLowerCase()))
    : companyIndustryOptions.value

  const optionsBySlug = new Map<string, CompanyIndustrySubcategory>()
  relevantIndustries.forEach((industry) => {
    industry.subcategories.forEach((subcategory) => {
      const key = subcategory.slug || subcategory.name.trim().toLowerCase()
      if (!VISIBLE_SUBCATEGORY_SLUGS.has(key)) return
      if (!optionsBySlug.has(key)) {
        optionsBySlug.set(key, subcategory)
      }
    })
  })

  return Array.from(optionsBySlug.values()).sort((a, b) => a.name.localeCompare(b.name))
})
const filteredCommodityOptions = computed(() => {
  const needle = commoditySearchQuery.value.trim().toLowerCase()
  if (!needle) {
    return []
  }

  return activeCommodityOptions.value.filter(
    (commodity) =>
      !selectedCommodities.value.includes(commodity) &&
      commodity.toLowerCase().includes(needle)
  )
})
const activeCompanySortMetric = computed<{ key: 'cash_in_bank' | 'cash_runway'; label: string } | null>(() => {
  if (activeMode.value !== 'company') return null
  if (sort.value.startsWith('cash_in_bank')) return { key: 'cash_in_bank', label: 'Cash in bank' }
  if (sort.value.startsWith('cash_runway')) return { key: 'cash_runway', label: 'Cash runway' }
  return null
})

const formatMarketCapValue = (value: number | string | null): string => {
  if (value === null || Number.isNaN(value)) return '—'
  return formatMarketCap(value)
}

const parseNumber = (value: number | string | null): number | null => {
  if (value === null || value === '') return null
  const parsed = typeof value === 'number' ? value : Number(String(value).replace(/[$,]/g, ''))
  return Number.isFinite(parsed) ? parsed : null
}

const formatAudCurrency = (value: number | string | null): string => {
  const amount = parseNumber(value)
  if (amount === null) return '—'
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  }).format(amount)
}

const formatCashRunway = (value: number | string | null): string => {
  const amount = parseNumber(value)
  if (amount === null) return '—'
  return `${amount} ${amount === 1 ? 'quarter' : 'quarters'}`
}

const formatActiveCompanySortValue = (company: CompanyListItem): string => {
  if (activeCompanySortMetric.value?.key === 'cash_in_bank') {
    return formatAudCurrency(company.cash_in_bank)
  }

  if (activeCompanySortMetric.value?.key === 'cash_runway') {
    return formatCashRunway(company.cash_runway)
  }

  return ''
}

const visibleCommodities = (commodities: string[]): string[] => commodities.slice(0, 3)
const stripProtocol = (website: string): string => website.replace(/^https?:\/\//i, '')
const normalizeWebsite = (website: string): string =>
  /^https?:\/\//i.test(website) ? website : `https://${website}`
const getCompanyResultId = (company: CompanyListItem): string | number => company.id ?? company.slug ?? company.name

const toggleCommodity = (commodity: string) => {
  selectedCommodities.value = selectedCommodities.value.includes(commodity)
    ? selectedCommodities.value.filter((item) => item !== commodity)
    : [...selectedCommodities.value, commodity]

  commoditySearchQuery.value = ''
}

const toggleIndustry = (industry: string) => {
  selectedIndustries.value = selectedIndustries.value.includes(industry)
    ? selectedIndustries.value.filter((item) => item !== industry)
    : [...selectedIndustries.value, industry]

  pruneSelectedIndustrySubcategories()
}

const pruneSelectedIndustrySubcategories = () => {
  const available = new Set(companySubcategoryOptions.value.map((subcategory) => subcategory.slug))
  selectedIndustrySubcategories.value = selectedIndustrySubcategories.value.filter((subcategory) =>
    available.has(subcategory)
  )
}

const toggleIndustrySubcategory = (subcategory: string) => {
  selectedIndustrySubcategories.value = selectedIndustrySubcategories.value.includes(subcategory)
    ? selectedIndustrySubcategories.value.filter((item) => item !== subcategory)
    : [...selectedIndustrySubcategories.value, subcategory]
}

const toggleEmployeeSize = (size: string) => {
  selectedEmployeeSizes.value = selectedEmployeeSizes.value.includes(size)
    ? selectedEmployeeSizes.value.filter((item) => item !== size)
    : [...selectedEmployeeSizes.value, size]
}

const toggleCashBand = (band: string) => {
  selectedCashBands.value = selectedCashBands.value.includes(band)
    ? selectedCashBands.value.filter((item) => item !== band)
    : [...selectedCashBands.value, band]
}

const toggleState = (state: string) => {
  selectedStates.value = selectedStates.value.includes(state)
    ? selectedStates.value.filter((item) => item !== state)
    : [...selectedStates.value, state]
}

const toggleProjectState = (state: string) => {
  selectedProjectStates.value = selectedProjectStates.value.includes(state)
    ? selectedProjectStates.value.filter((item) => item !== state)
    : [...selectedProjectStates.value, state]
}

const toggleProjectStage = (stage: string) => {
  selectedProjectStages.value = selectedProjectStages.value.includes(stage)
    ? selectedProjectStages.value.filter((item) => item !== stage)
    : [...selectedProjectStages.value, stage]
}

const clearCompanyFilters = () => {
  commoditySearchQuery.value = ''
  selectedCommodities.value = []
  selectedIndustrySubcategories.value = []
  selectedStates.value = []
  selectedCashBands.value = []
  selectedEmployeeSizes.value = []
  hasActiveJobs.value = false
}

const clearProjectFilters = () => {
  commoditySearchQuery.value = ''
  selectedCommodities.value = []
  selectedProjectStates.value = []
  selectedProjectStages.value = []
}

const clearFilters = () => {
  searchQuery.value = ''
  sort.value = defaultSortForMode(activeMode.value)
  selectedIndustries.value = []
  bookmarkedOnly.value = false

  if (activeMode.value === 'project') {
    clearProjectFilters()
  } else {
    clearCompanyFilters()
  }

  queueSearch()
}

const setMode = (mode: SearchMode) => {
  if (activeMode.value === mode) return

  activeMode.value = mode
  bookmarkedOnly.value = false
  commoditySearchQuery.value = ''
  sort.value = defaultSortForMode(mode)
  page.value = 1
  selectedResultId.value = null
  total.value = mode === 'project'
    ? (projectResultTotal.value ?? projectDirectoryTotal.value)
    : (companyResultTotal.value ?? companyDirectoryTotal.value)

  if (mode === 'project') {
    clearCompanyFilters()
    companyItems.value = []
  } else {
    clearProjectFilters()
    projectItems.value = []
  }

  queueSearch()
}

const setBookmarkedOnly = (enabled: boolean) => {
  bookmarkedOnly.value = enabled
  activeMode.value = 'company'
  searchQuery.value = ''
  sort.value = defaultSortForMode('company')
  selectedIndustries.value = []
  clearCompanyFilters()
  clearProjectFilters()
  projectItems.value = []
  page.value = 1
  selectedResultId.value = null
  queueSearch()
}

const handleBookmarkedOnlyChange = (event: Event) => {
  setBookmarkedOnly(Boolean((event.target as HTMLInputElement | null)?.checked))
}

const syncStateFromRoute = () => {
  isSyncingFromRoute.value = true

  const nextBookmarkedOnly = parseQueryString(route.query.bookmarked ?? route.query.bookmarked_only) === '1'
  const nextMode = nextBookmarkedOnly ? 'company' : parseMode(route.query.mode)
  activeMode.value = nextMode
  bookmarkedOnly.value = nextBookmarkedOnly
  searchQuery.value = nextBookmarkedOnly ? '' : parseQueryString(route.query.q)
  sort.value = parseQueryString(route.query.sort) || defaultSortForMode(nextMode)
  selectedIndustries.value = nextBookmarkedOnly ? [] : parseQueryArray(route.query.industries)
  selectedIndustrySubcategories.value =
    nextBookmarkedOnly || !SHOW_SUBCATEGORY_FILTER ? [] : parseQueryArray(route.query.industry_subcategories)
  selectedStates.value = nextBookmarkedOnly ? [] : parseQueryArray(route.query.states ?? route.query.state)
  selectedCashBands.value = nextBookmarkedOnly ? [] : parseQueryArray(route.query.cash)
  selectedCommodities.value = nextBookmarkedOnly ? [] : parseQueryArray(route.query.commodities)
  selectedEmployeeSizes.value = nextBookmarkedOnly ? [] : parseQueryArray(route.query.employee_sizes)
  hasActiveJobs.value = nextBookmarkedOnly ? false : parseQueryString(route.query.active_jobs) === '1'
  selectedProjectStages.value = nextBookmarkedOnly ? [] : parseQueryArray(route.query.project_stages)
  selectedProjectStates.value = nextBookmarkedOnly ? [] : parseQueryArray(route.query.project_states)
  page.value = parseQueryPage(route.query.page)

  isSyncingFromRoute.value = false
}

const buildRouteQuery = (nextPage = 1): Record<string, string | string[]> => {
  const query: Record<string, string | string[]> = {}

  if (bookmarkedOnly.value) {
    query.bookmarked = '1'
    if (nextPage > 1) {
      query.page = String(nextPage)
    }
    return query
  }

  if (activeMode.value === 'project') {
    query.mode = 'project'
  }
  if (searchQuery.value.trim()) {
    query.q = searchQuery.value.trim()
  }
  if (sort.value !== defaultSortForMode(activeMode.value)) {
    query.sort = sort.value
  }
  if (selectedIndustries.value.length) {
    query.industries = [...selectedIndustries.value]
  }

  if (activeMode.value === 'project') {
    if (selectedCommodities.value.length) {
      query.commodities = [...selectedCommodities.value]
    }
    if (selectedProjectStages.value.length) {
      query.project_stages = [...selectedProjectStages.value]
    }
    if (selectedProjectStates.value.length) {
      query.project_states = [...selectedProjectStates.value]
    }
  } else {
    if (selectedCommodities.value.length) {
      query.commodities = [...selectedCommodities.value]
    }
    if (selectedIndustrySubcategories.value.length) {
      query.industry_subcategories = [...selectedIndustrySubcategories.value]
    }
    if (selectedStates.value.length) {
      query.states = [...selectedStates.value]
    }
    if (hasActiveJobs.value) {
      query.active_jobs = '1'
    }
    if (selectedCashBands.value.length) {
      query.cash = [...selectedCashBands.value]
    }
    if (selectedEmployeeSizes.value.length) {
      query.employee_sizes = [...selectedEmployeeSizes.value]
    }
  }

  if (nextPage > 1) {
    query.page = String(nextPage)
  }

  return query
}

const syncRouteQuery = (nextPage = 1) => {
  const nextQuery = buildRouteQuery(nextPage)
  const currentQuery = JSON.stringify(route.query)
  const targetQuery = JSON.stringify(nextQuery)

  if (currentQuery === targetQuery) {
    return
  }

  lastLocallySyncedQuery.value = targetQuery
  router.replace({
    name: 'ContractorCompanySearch',
    query: nextQuery,
  })
}

const buildParams = (nextPage: number): Record<string, unknown> => {
  const params: Record<string, unknown> = {
    mode: activeMode.value,
    page: nextPage,
    per_page: PER_PAGE,
    sort: sort.value,
  }

  if (bookmarkedOnly.value) {
    return {
      mode: 'company',
      page: nextPage,
      per_page: PER_PAGE,
      sort: defaultSortForMode('company'),
      bookmarked_only: true,
    }
  }

  if (searchQuery.value.trim() !== '') {
    params.q = searchQuery.value.trim()
  }
  if (selectedIndustries.value.length) {
    params.industries = selectedIndustries.value
  }
  if (selectedCommodities.value.length) {
    params.commodities = selectedCommodities.value
  }
  if (activeMode.value === 'company' && selectedIndustrySubcategories.value.length) {
    params.industry_subcategories = selectedIndustrySubcategories.value
  }

  if (activeMode.value === 'project') {
    if (selectedProjectStages.value.length) {
      params.project_stages = selectedProjectStages.value
    }
    if (selectedProjectStates.value.length) {
      params.project_states = selectedProjectStates.value
    }
    return params
  }

  if (selectedStates.value.length) {
    params.states = selectedStates.value
  }
  if (hasActiveJobs.value) {
    params.has_active_jobs = true
  }
  if (selectedCashBands.value.length) {
    params.cash_in_bank_bands = selectedCashBands.value
  }
  if (selectedEmployeeSizes.value.length) {
    params.employee_sizes = selectedEmployeeSizes.value
  }

  return params
}

const handleMarkerClick = (id: string | number | null) => {
  selectedResultId.value = id
}

const setBookmarkSaving = (companyId: number, saving: boolean) => {
  const next = new Set(bookmarkSavingIds.value)
  if (saving) {
    next.add(companyId)
  } else {
    next.delete(companyId)
  }
  bookmarkSavingIds.value = next
}

const updateCompanyBookmarkState = (companyId: number, isBookmarked: boolean) => {
  companyItems.value = companyItems.value.map((company) =>
    company.id === companyId
      ? { ...company, is_bookmarked: isBookmarked }
      : company
  )
}

const toggleCompanyBookmark = async (company: CompanyListItem) => {
  if (!company.id || bookmarkSavingIds.value.has(company.id)) return

  const companyId = company.id
  const previousItems = companyItems.value
  const previousTotal = total.value
  const previousCompanyResultTotal = companyResultTotal.value
  const nextBookmarkedState = !company.is_bookmarked
  setBookmarkSaving(companyId, true)

  if (nextBookmarkedState) {
    updateCompanyBookmarkState(companyId, true)
  } else if (bookmarkedOnly.value) {
    companyItems.value = companyItems.value.filter((item) => item.id !== companyId)
    total.value = Math.max(0, total.value - 1)
    companyResultTotal.value = Math.max(0, (companyResultTotal.value ?? total.value) - 1)
  } else {
    updateCompanyBookmarkState(companyId, false)
  }

  try {
    if (nextBookmarkedState) {
      await bookmarkContractorCompany(companyId)
      return
    }

    await removeContractorCompanyBookmark(companyId)
  } catch (error) {
    console.error('Failed to update company bookmark', error)
    companyItems.value = previousItems
    total.value = previousTotal
    companyResultTotal.value = previousCompanyResultTotal
  } finally {
    setBookmarkSaving(companyId, false)
  }
}

const loadDirectoryCounts = async () => {
  try {
    const [{ data: companyData }, { data: projectData }] = await Promise.all([
      getContractorMiningCompanies({
        mode: 'company',
        page: 1,
        per_page: 1,
        sort: defaultSortForMode('company'),
      }),
      getContractorMiningCompanies({
        mode: 'project',
        page: 1,
        per_page: 1,
        sort: defaultSortForMode('project'),
      }),
    ])

    companyDirectoryTotal.value = Number(companyData?.pagination?.total ?? 0)
    projectDirectoryTotal.value = Number(projectData?.pagination?.total ?? 0)

    if (companyResultTotal.value === null) {
      companyResultTotal.value = companyDirectoryTotal.value
    }
    if (projectResultTotal.value === null) {
      projectResultTotal.value = projectDirectoryTotal.value
    }
  } catch (error) {
    companyDirectoryTotal.value = 0
    projectDirectoryTotal.value = 0
  }
}

const runSearch = async (nextPage = 1) => {
  if (!isAllowed.value && hasBootstrapped.value) return

  isLoading.value = true
  selectedResultId.value = null
  syncRouteQuery(nextPage)

  try {
    const { data } = await getContractorMiningCompanies(buildParams(nextPage))
    isAllowed.value = true
    const nextTotal = Number(data?.pagination?.total ?? 0)

    if (activeMode.value === 'company') {
      companyItems.value = Array.isArray(data?.items) ? data.items : []
      companyResultTotal.value = nextTotal
      projectItems.value = []
    } else {
      projectItems.value = Array.isArray(data?.items) ? data.items : []
      projectResultTotal.value = nextTotal
      companyItems.value = []
    }

    total.value = nextTotal
    page.value = Number(data?.pagination?.page ?? nextPage)
  } catch (error: any) {
    if (error?.response?.status === 403) {
      isAllowed.value = false
      companyItems.value = []
      projectItems.value = []
      total.value = 0
      page.value = 1
      companyResultTotal.value = null
      projectResultTotal.value = null
      return
    }

    companyItems.value = []
    projectItems.value = []
    total.value = 0
    page.value = 1
  } finally {
    hasBootstrapped.value = true
    isAccessLoading.value = false
    isLoading.value = false
  }
}

let searchTimer: ReturnType<typeof setTimeout> | null = null
const queueSearch = () => {
  console.log('running queue search')
  if (isSyncingFromRoute.value) return
  if (!isAllowed.value && hasBootstrapped.value) return
  if (searchTimer) clearTimeout(searchTimer)

  searchTimer = setTimeout(() => {
    runSearch(1)
  }, 350)
}

watch([activeMode, searchQuery, sort], () => {
  queueSearch()
})

watch(
  [
    () => selectedIndustries.value.slice(),
    () => selectedIndustrySubcategories.value.slice(),
    () => selectedStates.value.slice(),
    () => selectedCashBands.value.slice(),
    () => selectedCommodities.value.slice(),
    () => selectedEmployeeSizes.value.slice(),
    hasActiveJobs,
    () => selectedProjectStages.value.slice(),
    () => selectedProjectStates.value.slice(),
  ],
  () => {
    queueSearch()
  }
)

onMounted(async () => {
  getCompanyIndustryOptions()
    .then(({ data }) => {
      companyIndustryOptions.value = Array.isArray(data?.data) ? data.data : []
      pruneSelectedIndustrySubcategories()
    })
    .catch((error) => {
      console.error('Failed to fetch company industry options', error)
    })
  syncStateFromRoute()
  await runSearch(page.value)
  if (isAllowed.value) {
    await loadDirectoryCounts()
  }
})

onBeforeUnmount(() => {
  if (searchTimer) {
    clearTimeout(searchTimer)
  }
})

watch(
  () => route.query,
  (nextQuery, previousQuery) => {
    if (JSON.stringify(nextQuery) === JSON.stringify(previousQuery)) {
      return
    }

    const serializedNextQuery = JSON.stringify(nextQuery)
    if (lastLocallySyncedQuery.value === serializedNextQuery) {
      lastLocallySyncedQuery.value = null
      return
    }

    syncStateFromRoute()

    if (!hasBootstrapped.value) {
      return
    }

    if (searchTimer) {
      clearTimeout(searchTimer)
      searchTimer = null
    }

    runSearch(page.value)
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-[0.2em] text-gray-500" }, "Mining Directory", -1)),
          _createElementVNode("h1", _hoisted_4, _toDisplayString(pageTitle.value), 1)
        ]),
        (displayDirectoryTotal.value !== null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(displayDirectoryTotal.value.toLocaleString()) + " " + _toDisplayString(activeMode.value === 'project' ? 'projects' : 'companies'), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(pageSubtitle.value), 1)
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["inline-flex items-center gap-2 rounded-xl border px-4 py-2.5 text-sm font-semibold transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-sky-200", activeMode.value === 'company'
                ? 'border-sky-200 bg-sky-600 text-white shadow-md shadow-sky-100'
                : 'border-transparent bg-white/70 text-slate-600 hover:border-slate-300 hover:bg-white hover:text-slate-900']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setMode('company')))
            }, [
              _cache[12] || (_cache[12] = _createStaticVNode("<svg class=\"h-4 w-4\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" data-v-eeac3bf2><path d=\"M3 21h18\" data-v-eeac3bf2></path><path d=\"M5 21V7l7-4 7 4v14\" data-v-eeac3bf2></path><path d=\"M9 10h.01\" data-v-eeac3bf2></path><path d=\"M9 14h.01\" data-v-eeac3bf2></path><path d=\"M15 10h.01\" data-v-eeac3bf2></path><path d=\"M15 14h.01\" data-v-eeac3bf2></path></svg> Search Companies ", 2)),
              _createElementVNode("span", {
                class: _normalizeClass(["rounded-full px-2 py-0.5 text-[11px] font-bold", activeMode.value === 'company' ? 'bg-white/20 text-white ring-1 ring-white/25' : 'bg-slate-200 text-slate-700'])
              }, _toDisplayString(companyDirectoryTotal.value.toLocaleString()), 3)
            ], 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["inline-flex items-center gap-2 rounded-xl border px-4 py-2.5 text-sm font-semibold transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-amber-200", activeMode.value === 'project'
                ? 'border-amber-200 bg-amber-500 text-white shadow-md shadow-amber-100'
                : 'border-transparent bg-white/70 text-slate-600 hover:border-slate-300 hover:bg-white hover:text-slate-900']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setMode('project')))
            }, [
              _cache[13] || (_cache[13] = _createStaticVNode("<svg class=\"h-4 w-4\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" data-v-eeac3bf2><path d=\"M4 6h9v14H4z\" data-v-eeac3bf2></path><path d=\"M13 10h7v10h-7z\" data-v-eeac3bf2></path><path d=\"M8 10h.01\" data-v-eeac3bf2></path><path d=\"M16.5 14h.01\" data-v-eeac3bf2></path></svg> Search Projects ", 2)),
              _createElementVNode("span", {
                class: _normalizeClass(["rounded-full px-2 py-0.5 text-[11px] font-bold", activeMode.value === 'project' ? 'bg-white/20 text-white ring-1 ring-white/25' : 'bg-slate-200 text-slate-700'])
              }, _toDisplayString(projectDirectoryTotal.value.toLocaleString()), 3)
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Search", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            placeholder: searchPlaceholder.value,
            class: "h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 outline-none placeholder:text-slate-400 transition focus:border-newPrimary focus:ring-2 focus:ring-newPrimary/20"
          }, null, 8, _hoisted_11), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", {
            class: _normalizeClass(["inline-flex h-11 cursor-pointer items-center gap-2 rounded-lg border px-4 text-sm font-semibold transition", bookmarkedOnly.value
              ? 'border-newPrimary bg-newPrimary text-white shadow-sm'
              : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50'])
          }, [
            _createElementVNode("input", {
              checked: bookmarkedOnly.value,
              type: "checkbox",
              class: "sr-only",
              onChange: handleBookmarkedOnlyChange
            }, null, 40, _hoisted_13),
            _createVNode(_unref(Bookmark), {
              class: _normalizeClass(["h-4 w-4", { 'fill-current': bookmarkedOnly.value }])
            }, null, 8, ["class"]),
            _cache[15] || (_cache[15] = _createTextVNode(" Bookmarked only "))
          ], 2),
          _createElementVNode("button", {
            class: "h-11 rounded-lg border border-slate-300 px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-50",
            onClick: clearFilters
          }, " Reset all filters ")
        ])
      ])
    ]),
    (isAccessLoading.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_14, _cache[16] || (_cache[16] = [
          _createElementVNode("span", { class: "h-4 w-4 animate-spin rounded-full border-2 border-newPrimary/30 border-t-newPrimary" }, null, -1),
          _createTextVNode(" Checking your directory access... ")
        ])))
      : _createCommentVNode("", true),
    (!isAllowed.value && !isAccessLoading.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_15, " Mining company search is available for contractors registered in the mining or energy industry. "))
      : (_openBlock(), _createElementBlock("section", _hoisted_16, [
          _createElementVNode("aside", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "text-sm font-semibold uppercase tracking-wide text-slate-800" }, "Filters", -1)),
              (activeFilterCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(activeFilterCount.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Sort Results", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sort).value = $event)),
                  class: "h-10 w-full rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-900 outline-none transition focus:border-newPrimary focus:ring-2 focus:ring-newPrimary/20"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortOptions.value, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_22))
                  }), 128))
                ], 512), [
                  [_vModelSelect, sort.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Industry", -1)),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(INDUSTRY_FILTERS, (industry) => {
                    return _createElementVNode("label", {
                      key: industry.value,
                      class: "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm text-slate-700 transition hover:bg-slate-50"
                    }, [
                      _createElementVNode("input", {
                        checked: selectedIndustries.value.includes(industry.value),
                        type: "checkbox",
                        class: "h-4 w-4 rounded border-slate-300 text-newPrimary focus:ring-newPrimary/30",
                        onChange: ($event: any) => (toggleIndustry(industry.value))
                      }, null, 40, _hoisted_25),
                      _createElementVNode("span", null, _toDisplayString(industry.label), 1)
                    ])
                  }), 64))
                ])
              ]),
              (activeMode.value === 'company')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (SHOW_SUBCATEGORY_FILTER && companySubcategoryOptions.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _cache[20] || (_cache[20] = _createElementVNode("p", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Subcategory", -1)),
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companySubcategoryOptions.value, (subcategory) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: subcategory.slug || subcategory.name,
                                class: "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm text-slate-700 transition hover:bg-slate-50"
                              }, [
                                _createElementVNode("input", {
                                  checked: selectedIndustrySubcategories.value.includes(subcategory.slug),
                                  type: "checkbox",
                                  class: "h-4 w-4 rounded border-slate-300 text-newPrimary focus:ring-newPrimary/30",
                                  onChange: ($event: any) => (toggleIndustrySubcategory(subcategory.slug))
                                }, null, 40, _hoisted_28),
                                _createElementVNode("span", null, _toDisplayString(subcategory.name), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[21] || (_cache[21] = _createElementVNode("p", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Company Commodities", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((commoditySearchQuery).value = $event)),
                        type: "text",
                        placeholder: "Search commodities...",
                        class: "h-10 w-full rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-900 outline-none transition focus:border-newPrimary focus:ring-2 focus:ring-newPrimary/20"
                      }, null, 512), [
                        [_vModelText, commoditySearchQuery.value]
                      ]),
                      (selectedCommodities.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCommodities.value, (commodity) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: commodity,
                                type: "button",
                                class: "rounded-full border border-newPrimary bg-newPrimary px-3 py-1 text-xs font-semibold text-white transition hover:bg-newPrimary/90",
                                onClick: ($event: any) => (toggleCommodity(commodity))
                              }, _toDisplayString(commodity), 9, _hoisted_31))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (commoditySearchQuery.value.trim())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCommodityOptions.value, (commodity) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: commodity,
                                type: "button",
                                class: "rounded-full border border-slate-300 bg-white px-3 py-1 text-xs font-semibold text-slate-600 transition hover:border-newPrimary hover:text-slate-900",
                                onClick: ($event: any) => (toggleCommodity(commodity))
                              }, _toDisplayString(commodity), 9, _hoisted_33))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (commoditySearchQuery.value.trim() && filteredCommodityOptions.value.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_34, " No active commodities match your search. "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[22] || (_cache[22] = _createElementVNode("p", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Head Office State", -1)),
                      _createElementVNode("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stateOptions.value, (state) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: `company-${state.value}`,
                            class: "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm text-slate-700 transition hover:bg-slate-50"
                          }, [
                            _createElementVNode("input", {
                              checked: selectedStates.value.includes(state.value),
                              type: "checkbox",
                              class: "h-4 w-4 rounded border-slate-300 text-newPrimary focus:ring-newPrimary/30",
                              onChange: ($event: any) => (toggleState(state.value))
                            }, null, 40, _hoisted_37),
                            _createElementVNode("span", null, _toDisplayString(state.label), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _cache[23] || (_cache[23] = _createElementVNode("p", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Cash in Bank (AUD)", -1)),
                      _createElementVNode("div", _hoisted_39, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(CASH_BANDS.filter((item) => item.value !== ''), (option) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: option.value,
                            class: "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm text-slate-700 transition hover:bg-slate-50"
                          }, [
                            _createElementVNode("input", {
                              checked: selectedCashBands.value.includes(option.value),
                              type: "checkbox",
                              class: "h-4 w-4 rounded border-slate-300 text-newPrimary focus:ring-newPrimary/30",
                              onChange: ($event: any) => (toggleCashBand(option.value))
                            }, null, 40, _hoisted_40),
                            _createElementVNode("span", null, _toDisplayString(option.label), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _cache[24] || (_cache[24] = _createElementVNode("p", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Employee Size", -1)),
                      _createElementVNode("div", _hoisted_42, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EMPLOYEE_SIZE_FILTERS), (size) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: size,
                            class: "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm text-slate-700 transition hover:bg-slate-50"
                          }, [
                            _createElementVNode("input", {
                              checked: selectedEmployeeSizes.value.includes(size),
                              type: "checkbox",
                              class: "h-4 w-4 rounded border-slate-300 text-newPrimary focus:ring-newPrimary/30",
                              onChange: ($event: any) => (toggleEmployeeSize(size))
                            }, null, 40, _hoisted_43),
                            _createElementVNode("span", null, _toDisplayString(size), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _cache[26] || (_cache[26] = _createElementVNode("p", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Hiring Activity", -1)),
                      _createElementVNode("label", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((hasActiveJobs).value = $event)),
                          type: "checkbox",
                          class: "h-4 w-4 rounded border-slate-300 text-newPrimary focus:ring-newPrimary/30"
                        }, null, 512), [
                          [_vModelCheckbox, hasActiveJobs.value]
                        ]),
                        _cache[25] || (_cache[25] = _createElementVNode("span", null, "Companies with active jobs", -1))
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_46, [
                      _cache[27] || (_cache[27] = _createElementVNode("p", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Project Location", -1)),
                      _createElementVNode("div", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stateOptions.value, (state) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: `project-${state.value}`,
                            class: "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm text-slate-700 transition hover:bg-slate-50"
                          }, [
                            _createElementVNode("input", {
                              checked: selectedProjectStates.value.includes(state.value),
                              type: "checkbox",
                              class: "h-4 w-4 rounded border-slate-300 text-newPrimary focus:ring-newPrimary/30",
                              onChange: ($event: any) => (toggleProjectState(state.value))
                            }, null, 40, _hoisted_48),
                            _createElementVNode("span", null, _toDisplayString(state.label), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _cache[28] || (_cache[28] = _createElementVNode("p", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Project Commodities", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((commoditySearchQuery).value = $event)),
                        type: "text",
                        placeholder: "Search commodities...",
                        class: "h-10 w-full rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-900 outline-none transition focus:border-newPrimary focus:ring-2 focus:ring-newPrimary/20"
                      }, null, 512), [
                        [_vModelText, commoditySearchQuery.value]
                      ]),
                      (selectedCommodities.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCommodities.value, (commodity) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: commodity,
                                type: "button",
                                class: "rounded-full border border-newPrimary bg-newPrimary px-3 py-1 text-xs font-semibold text-white transition hover:bg-newPrimary/90",
                                onClick: ($event: any) => (toggleCommodity(commodity))
                              }, _toDisplayString(commodity), 9, _hoisted_51))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (commoditySearchQuery.value.trim())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCommodityOptions.value, (commodity) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: commodity,
                                type: "button",
                                class: "rounded-full border border-slate-300 bg-white px-3 py-1 text-xs font-semibold text-slate-600 transition hover:border-newPrimary hover:text-slate-900",
                                onClick: ($event: any) => (toggleCommodity(commodity))
                              }, _toDisplayString(commodity), 9, _hoisted_53))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (commoditySearchQuery.value.trim() && filteredCommodityOptions.value.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_54, " No active commodities match your search. "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _cache[29] || (_cache[29] = _createElementVNode("p", { class: "block text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Project Stage", -1)),
                      _createElementVNode("div", _hoisted_56, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PROJECT_STAGES), (stage) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: stage,
                            class: "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm text-slate-700 transition hover:bg-slate-50"
                          }, [
                            _createElementVNode("input", {
                              checked: selectedProjectStages.value.includes(stage),
                              type: "checkbox",
                              class: "h-4 w-4 rounded border-slate-300 text-newPrimary focus:ring-newPrimary/30",
                              onChange: ($event: any) => (toggleProjectStage(stage))
                            }, null, 40, _hoisted_57),
                            _createElementVNode("span", null, _toDisplayString(stage), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("p", _hoisted_61, _toDisplayString(resultsSummary.value), 1),
                _createElementVNode("p", _hoisted_62, "Page " + _toDisplayString(page.value) + " of " + _toDisplayString(totalPages.value), 1)
              ]),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "flex items-center justify-center rounded-xl border border-slate-200 bg-white py-5" }, [
                      _createElementVNode("span", { class: "h-5 w-5 animate-spin rounded-full border-2 border-newPrimary/30 border-t-newPrimary" })
                    ], -1)),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                      return _createElementVNode("div", {
                        key: n,
                        class: "h-24 animate-pulse rounded-xl border border-slate-200 bg-slate-50"
                      })
                    }), 64))
                  ]))
                : (bookmarkedOnly.value && companyItems.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, " You haven't bookmarked any companies yet. Bookmark companies from the directory to see them here. "))
                  : (activeMode.value === 'company' && companyItems.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, " No mining companies match your search yet. "))
                    : (activeMode.value === 'project' && projectItems.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, " No mining projects match your search yet. "))
                      : (activeMode.value === 'company')
                        ? (_openBlock(), _createBlock(_TransitionGroup, {
                            key: 4,
                            name: "company-list",
                            tag: "div",
                            class: "space-y-3"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyItems.value, (company) => {
                                return (_openBlock(), _createElementBlock("article", {
                                  key: company.slug || `${company.id}-${company.name}`,
                                  class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition hover:border-slate-300 hover:shadow-md",
                                  onMouseenter: ($event: any) => (selectedResultId.value = getCompanyResultId(company)),
                                  onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (selectedResultId.value = null))
                                }, [
                                  _createElementVNode("div", _hoisted_68, [
                                    _createElementVNode("div", _hoisted_69, [
                                      _createElementVNode("div", _hoisted_70, [
                                        (company.logo)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                              _createElementVNode("img", {
                                                src: company.logo,
                                                alt: company.name,
                                                class: "max-h-8 max-w-full object-contain"
                                              }, null, 8, _hoisted_72)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_73, [
                                          _createElementVNode("div", _hoisted_74, [
                                            (company.slug)
                                              ? (_openBlock(), _createBlock(_component_router_link, {
                                                  key: 0,
                                                  to: { name: 'ContractorCompanyPage', params: { slug: company.slug }, query: _unref(route).query },
                                                  class: "truncate text-base font-semibold leading-tight text-slate-900 hover:text-newPrimary"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(company.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"]))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(company.name), 1)),
                                            (company.is_private_company)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_76, " Private "))
                                              : _createCommentVNode("", true),
                                            (company.industry_subcategory)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(company.industry_subcategory), 1))
                                              : _createCommentVNode("", true),
                                            (company.id)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 4,
                                                  type: "button",
                                                  class: _normalizeClass(["inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition focus:outline-none focus:ring-2 focus:ring-newPrimary/20 disabled:cursor-not-allowed disabled:opacity-60", company.is_bookmarked
                              ? 'border-newPrimary bg-newPrimary text-white hover:bg-newPrimary/90'
                              : 'border-slate-300 bg-white text-slate-500 hover:border-newPrimary hover:text-newPrimary']),
                                                  disabled: bookmarkSavingIds.value.has(company.id),
                                                  "aria-label": company.is_bookmarked ? `Remove ${company.name} bookmark` : `Bookmark ${company.name}`,
                                                  title: company.is_bookmarked ? 'Remove bookmark' : 'Bookmark company',
                                                  onClick: _withModifiers(($event: any) => (toggleCompanyBookmark(company)), ["stop"])
                                                }, [
                                                  _createVNode(_unref(Bookmark), {
                                                    class: _normalizeClass(["h-4 w-4", { 'fill-current': company.is_bookmarked }])
                                                  }, null, 8, ["class"])
                                                ], 10, _hoisted_78))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_79, [
                                            (company.office_address)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  class: "max-w-full truncate sm:max-w-[320px]",
                                                  title: company.office_address
                                                }, _toDisplayString(company.office_address), 9, _hoisted_80))
                                              : _createCommentVNode("", true),
                                            (company.website)
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 1,
                                                  href: normalizeWebsite(company.website),
                                                  target: "_blank",
                                                  rel: "noopener noreferrer",
                                                  class: "font-semibold text-newPrimary hover:underline"
                                                }, _toDisplayString(stripProtocol(company.website)), 9, _hoisted_81))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (company.summary)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_82, _toDisplayString(company.summary), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_83, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleCommodities(company.commodities), (commodity) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: commodity,
                                            class: "rounded-full bg-sky-50 px-2.5 py-1 text-[11px] font-semibold text-sky-700 ring-1 ring-sky-100"
                                          }, _toDisplayString(commodity), 1))
                                        }), 128)),
                                        (company.commodities.length > 3)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_84, " +" + _toDisplayString(company.commodities.length - 3) + " more ", 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_85, [
                                      _createElementVNode("div", null, [
                                        _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-[11px] font-semibold uppercase tracking-wide text-slate-500" }, "Market cap", -1)),
                                        (company.is_private_company)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_86, "Private"))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(formatMarketCapValue(company.market_cap)), 1))
                                      ]),
                                      (activeCompanySortMetric.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                            _createElementVNode("p", _hoisted_89, _toDisplayString(activeCompanySortMetric.value.label), 1),
                                            _createElementVNode("p", _hoisted_90, _toDisplayString(formatActiveCompanySortValue(company)), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ], 40, _hoisted_67))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_TransitionGroup, {
                            key: 5,
                            name: "company-list",
                            tag: "div",
                            class: "space-y-3"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectItems.value, (project) => {
                                return (_openBlock(), _createElementBlock("article", {
                                  key: project.id,
                                  class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition hover:border-slate-300 hover:shadow-md",
                                  onMouseenter: ($event: any) => (selectedResultId.value = project.id),
                                  onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (selectedResultId.value = null))
                                }, [
                                  _createElementVNode("div", _hoisted_92, [
                                    _createElementVNode("div", _hoisted_93, [
                                      _createElementVNode("div", _hoisted_94, [
                                        _createElementVNode("h2", _hoisted_95, _toDisplayString(project.name || `${project.company_name} project`), 1),
                                        (project.stage)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(project.stage), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_97, [
                                        (project.company_slug)
                                          ? (_openBlock(), _createBlock(_component_router_link, {
                                              key: 0,
                                              to: { name: 'ContractorCompanyPage', params: { slug: project.company_slug }, query: _unref(route).query },
                                              class: "font-semibold text-newPrimary hover:underline"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(project.company_name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(project.company_name), 1)),
                                        (project.location_label)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(project.location_label), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (project.description)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_100, _toDisplayString(project.description), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_101, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleCommodities(project.commodities), (commodity) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: commodity,
                                            class: "rounded-full bg-sky-50 px-2.5 py-1 text-[11px] font-semibold text-sky-700 ring-1 ring-sky-100"
                                          }, _toDisplayString(commodity), 1))
                                        }), 128)),
                                        (project.commodities.length > 3)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_102, " +" + _toDisplayString(project.commodities.length - 3) + " more ", 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (project.activity_feed?.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                            _createElementVNode("p", _hoisted_104, [
                                              _cache[32] || (_cache[32] = _createTextVNode(" Latest update ")),
                                              (project.activity_feed[0].date)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_105, " · " + _toDisplayString(_unref(formatDateAsDayMonthYear)(project.activity_feed[0].date)), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("p", _hoisted_106, _toDisplayString(project.activity_feed[0].text), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_107, [
                                      _createElementVNode("div", null, [
                                        _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-[11px] font-semibold uppercase tracking-wide text-slate-500" }, "Project location", -1)),
                                        _createElementVNode("p", _hoisted_108, _toDisplayString(project.location_label || 'Not provided'), 1)
                                      ])
                                    ])
                                  ])
                                ], 40, _hoisted_91))
                              }), 128))
                            ]),
                            _: 1
                          })),
              (totalPages.value > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                    _createElementVNode("button", {
                      class: "rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-600 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50",
                      disabled: page.value <= 1 || isLoading.value,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (runSearch(page.value - 1)))
                    }, " Previous ", 8, _hoisted_110),
                    _createElementVNode("span", _hoisted_111, _toDisplayString(page.value), 1),
                    _createElementVNode("button", {
                      class: "rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-600 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50",
                      disabled: page.value >= totalPages.value || isLoading.value,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (runSearch(page.value + 1)))
                    }, " Next ", 8, _hoisted_112)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("aside", _hoisted_113, [
              _createVNode(CompanyDirectoryMap, {
                mode: activeMode.value,
                companies: mappableCompanies.value,
                projects: projectItems.value,
                "selected-id": selectedResultId.value,
                onMarkerClick: handleMarkerClick
              }, null, 8, ["mode", "companies", "projects", "selected-id"])
            ])
          ])
        ]))
  ]))
}
}

})